import { type HighlightsController } from '@databases/highlights';
import { createFillHandleEffect } from '@databases/selections';
import { getService } from '@databases/service-container';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FillHandleEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFillHandleEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_HANDLE_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE && ctx.permissions.canEditContent,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFillHandleEffect(highlightsController);
    },
  };
}
